import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './queryClient';
import './index.css';
import App from './App';
import store from "./state/store";

// Create root first
const container = document.getElementById('root');
const root = createRoot(container);

// Then render to root
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <App />
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);